import { useLocation } from "react-router-dom";

const ErrorPage = () => {
  const location = useLocation();
  const { error } = location.state;
  return (
    <>
      <div className="error-container">
        <div className="text-center mt-5">
          <h2 className="text-warning">Error</h2>          
            <p className="text-center">
              {error?.message && <span>{error.message}</span>}
            </p>
            <p>
              {error?.responseData && <span>{error?.responseData?.detail}</span>}
            </p>          
        </div>
      </div>
    </>
  );
};

export default ErrorPage;
